/**
 * WidgetChatCover — scroll-away media hero for widget sessions.
 *
 * Do not show the widget's catalog cover here. Capture sessions should feel
 * anchored to what the user just sent: no uploaded media means no hero; an
 * uploaded image renders as the session hero.
 */
import { normalizeMediaUrl } from '../../utils/session';

function firstPhoto(session) {
  const ctx = session?.context || session?.exec_context || {};
  const photos = ctx.photos;
  if (!Array.isArray(photos) || photos.length === 0) return null;
  const first = photos[0];
  if (typeof first === 'string') return first;
  if (first && typeof first === 'object') {
    return first.url || first.preview_url || first.signed_url || first.media_url || null;
  }
  return null;
}

export default function WidgetChatCover({ session }) {
  const isMain = session?.session_type === 'widget_main';
  const src = firstPhoto(session);
  if (!isMain || !src) return null;
  const url = normalizeMediaUrl(src);
  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
      <img
        src={url}
        alt=""
        style={{
          width: 240,
          maxWidth: '100%',
          maxHeight: 170,
          borderRadius: 14,
          objectFit: 'cover',
          display: 'block',
        }}
        onError={e => { e.currentTarget.style.display = 'none'; }}
      />
    </div>
  );
}
